var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5,16h6c1.105,0,2-0.895,2-2V2c0-1.105-0.895-2-2-2H5C3.895,0,3,0.895,3,2v12C3,15.105,3.895,16,5,16z M4,2h8v12H4V2z"}));
}

Mobile.defaultProps = {"id":"Layer_1_1_","style":{"enableBackground":"new 0 0 16 16"},"version":"1.1","viewBox":"0 0 16 16","xmlSpace":"preserve"};

module.exports = Mobile;

Mobile.default = Mobile;
